import { useState, useEffect } from "react";
import TileView from "./tile.view";
import TableView from "./table.view";
import { RowsIcon, SquareIcon,SquaresFourIcon,GridFourIcon, SquareSplitVerticalIcon } from "@phosphor-icons/react";
import { useProfile } from "context/profile.context";
const OverviewCard = ({ isAsset, isLiability, editEntry, onAddClick }) => {
    const { defaultView, updateProfile } = useProfile();

    const [view, setView] = useState(defaultView);

    useEffect(() => {
        setView(defaultView);
    }, [defaultView]);

    const changeView = (newView) => {
        setView(newView);
        updateProfile({ default_view: newView });
    };

    var heading

    if (isAsset) { heading = "Personal Assets" } 
    if (isLiability) { heading = "Personal Liabilities" }

    return (
        <>
            <div className="flex row space center">
                <p className="large padding"> {heading}</p>
              

                <div className="button-group icon-only">
                    <input type="radio" value="Individual" checked={view === "tiles"} readOnly /> <label htmlFor="Individual" className="medium" onClick={() => changeView("tiles")} > <SquareIcon size={14} /></label>
                    <input type="radio" value="Categories" checked={view === "tables"} readOnly /> <label htmlFor="Categories" className="medium"  onClick={() => changeView("tables")} ><SquareSplitVerticalIcon  size={14}  /> </label>
                </div>

        
            </div>

            {view === "tables" && (<TableView isAsset={isAsset} editEntry={editEntry} />)}
            {view === "tiles" && (<TileView isAsset={isAsset} editEntry={editEntry} onAddClick={onAddClick} />)}
        </>
    );
};

export default OverviewCard;
